import { render } from "./RodamientoAgricola.vue?vue&type=template&id=6c56a808&scoped=true"
import script from "./RodamientoAgricola.vue?vue&type=script&lang=js"
export * from "./RodamientoAgricola.vue?vue&type=script&lang=js"

import "./RodamientoAgricola.vue?vue&type=style&index=0&id=6c56a808&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c56a808"]])

export default __exports__